module.exports = __webpack_public_path__ + "static/OhCleo__Pink-ebd9647bc063af89081d24541a4648ff.svg";